import React, { useState } from 'react';
import Icon from './Icon';
import '../styles/components/ActivityLog.css';
import EmptyState from './EmptyState';

interface Activity {
  id: string;
  action: string;
  timestamp: string;
  user: string;
}

interface ActivityLogProps {
  activities: Activity[];
  title?: string;
  className?: string;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
}

const ActivityLog: React.FC<ActivityLogProps> = ({
  activities,
  title = 'Activity Log',
  className = '',
  collapsible = true,
  defaultCollapsed,
}) => {
  const isEmpty = !activities || activities.length === 0;
  const [collapsed, setCollapsed] = useState(defaultCollapsed ?? isEmpty);

  const header = (
    <button
      className="activity-log-toggle"
      onClick={() => setCollapsed(c => !c)}
      aria-expanded={!collapsed}
      type="button"
    >
      <span className="activity-log-title">{title}</span>
      {!isEmpty && (
        <span className="activity-log-count">{activities.length}</span>
      )}
      <Icon name={collapsed ? 'chevronDown' : 'chevronUp'} size={14} />
    </button>
  );

  return (
    <div className={`activity-log-section ${className}`}>
      {collapsible ? (
        header
      ) : (
        <h2 className="section-title">{title}</h2>
      )}

      {!collapsed && (
        isEmpty ? (
          <EmptyState compact title="No activities recorded" />
        ) : (
          <div className="activity-log-rows">
            {activities.map((activity, index) => (
              <div key={activity.id} className={`activity-row ${index % 2 === 0 ? 'even' : 'odd'}`}>
                <div className="activity-icon">
                  <span className="activity-dot" />
                </div>
                <div className="activity-content">
                  <span className="activity-action">
                    <strong>{activity.action}</strong>
                  </span>
                  <span className="activity-meta">
                    {activity.timestamp} · by {activity.user}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default ActivityLog;
